<template lang="pug">
  table.table.table-bordered.table_document
    tr
      td Имеются ли у Вас хронические заболевания?
      td {{formatAnswer(data.body.content.chronic_disease, 1)}}
    tr
      td Предъявляете ли Вы жалобы по поводу своего здоровья?
      td {{formatAnswer(data.body.content.health_complaints, 1)}}
    tr
      td Отмечали ли Вы дискомфорт или боли, покалывание, давление, сжимание за грудиной или в области сердца?
      td {{formatAnswer(data.body.content.discomfort_in_the_heart_area, 1)}}
    tr
      td В вашем роду были ли инфаркты сердца, инсульты, внезапная смерть у прямых родственников (родители, братья, сестры, бабушки, дедушки) в возрасте до 55 лет (у мужчин), 65 (у женщин)?
      td {{formatAnswer(data.body.content.bad_hereditary, 1)}}
    tr
      td Бывали у Вас подъемы АД 140/90 мм рт ст и выше?
      td {{formatAnswer(data.body.content.high_blood_pressure, 1)}}
    tr
      td Отмечались ли у Вас изменения на ЭКГ потребовавшие лечения?
      td {{formatAnswer(data.body.content.ecg_changes, 1)}}
    tr
      td Курите ли Вы?
      td {{formatAnswer(data.body.content.smoking, 1)}}
    tr
      td Укажите, сколько лет
      td {{formatAnswer(data.body.content.age, 2)}}
    tr
      td Возникает ли у Вас затрудненное дыхание при подъеме по лестнице?
      td {{formatAnswer(data.body.content.difficulty_breathing, 1)}}
    tr
      td Беспокоят ли Вас приступы кашля в настоящее время?
      td {{formatAnswer(data.body.content.cough, 1)}}
    tr
      td Выделяется ли у Вас мокрота в настоящее время?
      td {{formatAnswer(data.body.content.sputum, 1)}}
    tr
      td Бывает ли у Вас длительно заложен нос?
      td {{formatAnswer(data.body.content.blocked_nose, 1)}}
    tr
      td Чувствуете ли Вы ухудшение состояния органов дыхания после простуды (ОРЗ)?
      td {{formatAnswer(data.body.content.deterioration_of_the_respiratory_system, 1)}}
    tr
      td Принимали ли Вы лекарства в связи со следующими состояниями:
      td
        table.table.table-bordered.table_document
          tr
            td высоким АД
            td {{formatAnswer(data.body.content.high_blood_pressure_medicine, 1)}}
          tr
            td заболеванием сердца
            td {{formatAnswer(data.body.content.heart_disease_medicine, 1)}}
          tr
            td высоким уровнем холестерина крови
            td {{formatAnswer(data.body.content.high_cholesterol_medicine, 1)}}
          tr
            td хроническими заболеваниями легких
            td {{formatAnswer(data.body.content.chronic_lung_disease_medicine, 1)}}

    tr
      td Отмечаете ли Вы в последние полгода:
      td
        table.table.table-bordered.table_document
          tr
            td приступы потери сознания
            td {{formatAnswer(data.body.content.loss_of_consciousness, 1)}}
          tr
            td головокружения
            td {{formatAnswer(data.body.content.dizziness, 1)}}
          tr
            td нарушение сна (трудность заснуть, пробуждения ночью)
            td {{formatAnswer(data.body.content.sleep_disturbance, 1)}}
          tr
            td ухудшение памяти
            td {{formatAnswer(data.body.content.memory_impairment, 1)}}

    tr
      td Отмечали ли Вы за последний месяц:
      td
        table.table.table-bordered.table_document
          tr
            td тошноту
            td {{formatAnswer(data.body.content.nausea, 1)}}
          tr
            td изжогу
            td {{formatAnswer(data.body.content.heartburn, 1)}}
          tr
            td тяжесть в верхней части живота
            td {{formatAnswer(data.body.content.heaviness, 1)}}
          tr
            td горечь во рту
            td {{formatAnswer(data.body.content.bitterness, 1)}}
          tr
            td боли в животе
            td {{formatAnswer(data.body.content.abdominal_pains, 1)}}
          tr
            td нарушение стула
            td {{formatAnswer(data.body.content.violation_of_defecation, 1)}}

    tr
      td Отмечали ли Вы за последние пол года примесь крови в стуле?
      td {{formatAnswer(data.body.content.blood_in_the_stool, 1)}}
    tr
      td Отмечали ли Вы за последние пол года уменьшение веса?
      td {{formatAnswer(data.body.content.reducing_weight, 1)}}
    tr
      td Были ли у Вас в роду (родители, братья, сестры) случаи онкологических заболеваний?
      td {{formatAnswer(data.body.content.bad_genes, 1)}}
    tr
      td Бывает ли  у Вас кровоточивость десен, носовые кровотечения?
      td {{formatAnswer(data.body.content.bleeding_gums, 1)}}
    tr
      td Отмечаете ли Вы дискомфорт или боли в суставах?
      td {{formatAnswer(data.body.content.joint_pain, 1)}}
    tr
      td Отмечаете ли Вы высыпания на коже в настоящее время?
      td {{formatAnswer(data.body.content.skin_eruption, 1)}}
    tr
      td Отмечаете ли Вы кожный зуд в настоящее время?
      td {{formatAnswer(data.body.content.skin_itch, 1)}}
    tr
      td Занимаетесь ли Вы физкультурой?
      td {{formatAnswer(data.body.content.physical_education, 1)}}
    tr
      td В целом, Вы бы оценили состояние Вашего здоровья как
      td {{formatAnswer(data.body.content.health_status, 2)}}
    tr
      td Как бы Вы в целом оценили свое здоровье сейчас по сравнению с тем, что было год назад?
      td {{formatAnswer(data.body.content.comparison_of_health_status, 2)}}
    tr
      td Как часто в течение последних 4 недель:
      td
        table.table.table-bordered.table_document
          tr
            td Вы чувствовали себя бодрым(ой)?
            td {{formatAnswer(data.body.content.sense_of_vitality, 2)}}
          tr
            td Вы сильно нервничали?
            td {{formatAnswer(data.body.content.very_nervous, 2)}}
          tr
            td Вы чувствовали себя таким(ой) подавленным(ой), что ничто Вас не могло взбодрить?
            td {{formatAnswer(data.body.content.feeling_of_depression, 2)}}
          tr
            td Вы чувствовали себя спокойным(ой) и уверенным(ой)?
            td {{formatAnswer(data.body.content.peace_of_mind_and_confidence, 2)}}
          tr
            td Вы чувствовали себя полным(ой) сил и энергии?
            td {{formatAnswer(data.body.content.full_of_energy, 2)}}
          tr
            td Вы чувствовали себя измученным(ой)?
            td {{formatAnswer(data.body.content.feeling_exhausted, 2)}}
          tr
            td Вы чувствовали себя счастливым(ой)?
            td {{formatAnswer(data.body.content.feeling_of_happiness, 2)}}
          tr
            td Вы чувствовали себя упавшим(ей) духом и печальным(ой)?
            td {{formatAnswer(data.body.content.feeling_of_sadness, 2)}}
          tr
            td Вы чувствовали себя уставшим(ей)?
            td {{formatAnswer(data.body.content.feeling_tired, 2)}}
</template>
<script>
export default {
  props: ['data'],

  methods: {
    formatAnswer (fact, type) {
      switch (type) {
        case 1:
          return fact !== undefined ? (fact ? 'Да' : 'Нет') : '—'
        case 2:
          return fact || '—'
        case 3:
          return fact ? fact.name : '—'
      }
    }
  }
}
</script>
<style lang="sass" scoped>
@import "@/css/DocumentStyles.sass"
</style>
